export default __webpack_public_path__ + "locales/az/DeleteThirdPartyDialog.json?hash=ed503422534a61a2394bd33bd7c528b6";